import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025. Juego de Ajedrez. Desarrollado por DeibyOd. Todos los derechos reservados. v1.0</p>
    </footer>
  );
};

export default Footer;